export default __webpack_public_path__ + "static/media/bg-ball1.c47c5979.png";